export default __webpack_public_path__ + "static/sonochemistry-c85bb17208f27529ba5b15693b8b668e.svg";